import { type BaseContext } from '../state-machine-types.ts';

export const keep = <T extends BaseContext>(ctx: T) => ctx;
